var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_vm._v("404")]),_c('h1',{staticClass:"title"},[_vm._v("页面不存在")]),_c('p',{staticClass:"desc"},[_vm._v("抱歉，您访问的页面不存在或已被删除")]),_c('button',{staticClass:"btn-back",on:{"click":_vm.goHome}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }